/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TriggerDefinition,
  TriggerDefinition$inboundSchema,
} from "./triggerdefinition.js";

export type ListTriggerDefinitionsResult = {
  /**
   * The available trigger definitions.
   */
  definitions: Array<TriggerDefinition>;
};

/** @internal */
export const ListTriggerDefinitionsResult$inboundSchema: z.ZodMiniType<
  ListTriggerDefinitionsResult,
  unknown
> = z.object({
  definitions: z.array(TriggerDefinition$inboundSchema),
});

export function listTriggerDefinitionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListTriggerDefinitionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTriggerDefinitionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTriggerDefinitionsResult' from JSON`,
  );
}
